//PBI 93117 - [RI Digital] Ajustar sobreposição do menu suspenso em páginas com dropdown
document.addEventListener("DOMContentLoaded", function () {
    const menuItemsComDropdown = document.querySelectorAll(".ri-digital__menu-item:has(.ri-digital__dropdown), .ri-digital__onr");

    if (menuItemsComDropdown.length > 0) {
        [...menuItemsComDropdown]?.forEach((item) => {
            item.addEventListener("mouseenter", () => {
                const active = document.activeElement;

                if (active && (active.tagName === "SELECT" || active.tagName === "INPUT" || active.tagName === "IFRAME")) {
                    active.blur();
                }
            });
        });
    }
})